import { makeStyles } from 'tss-react/mui'
import { lighten } from '@mui/material'

export default makeStyles()(theme => ({
  backdrop: {
    position: 'absolute' as const,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: `linear-gradient(${theme.palette.primary.main}, ${lighten(theme.palette.primary.main, 0.1)})`,
    transformOrigin: 'center top',
  },
  header: {
    paddingTop: theme.spacing(12),
    paddingBottom: theme.spacing(8),
    width: '100%',
    boxSizing: 'border-box' as const,
    position: 'relative' as const,
    '&.wide .header-content': {
      width: theme.breakpoints.values.lg,
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    },
  },
  alternative: {
    color: `${theme.palette.text.dark} !important`,
    '& > .header-content > *': {
      color: `${theme.palette.text.dark} !important`,
    },
    '& .alt-backdrop': {
      opacity: 1,
    },
  },
  altBackdrop: {
    position: 'absolute' as const,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: `linear-gradient(${'#FFF'}, #f0f0f0)`,
    borderBottom: `1px solid ${'rgba(255, 255, 255, 0.4)'}`,
    opacity: 0,
  },
  compact: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(6),
  },
  white: {
    '& .alt-backdrop': {
      borderBottom: 'none',
      background: '#FFF',
    },
  },
  headerContent: {
    width: theme.breakpoints.values.md,
    maxWidth: 'calc(100% - 24px)',
    margin: '0 auto',
    textAlign: 'left' as const,
    position: 'relative' as const,
    zIndex: 4,
  },
  sidebarColumn: {
    '& .header-content': {
      margin: `0 ${theme.spacing(2)} 0 auto !important`,
    },
  },
  background: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: '0',
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
  },
  backgroundOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: '1',
    width: '100%',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.46)',
    boxShadow: '0 -10px 8px rgba(0, 0, 0, 0.24) inset',
  },
}))
